var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// $FlowFixMe
import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getColorFromBackground } from 'app/libs/helpers/getColorFromBackground.js';
import { MUIButton } from 'app/components/Form';
import { ModalTrigger, confirmDelete } from 'app/components/Modal';
import { Permission } from 'app/containers/Permissions/Permission.jsx';
import Widget from 'app/components/Widget/Widget.jsx';
import Loader from 'app/components/Loader/Loader.jsx';
import Tooltip from '@mui/material/Tooltip';
import EditFlagModal from 'app/pages/Project/Settings/Flags/ModalEditFlag';
import classes from 'app/pages/Project/Settings/Flags/Flags.module.scss';
import { deleteFlag, fetchFlags, fetchFlagsBySearch, setFlagsAreLoading } from 'app/store/reducers/reduxFlags';
import { reduxFlagsDataSelector, reduxFlagsLoadingSelector } from 'app/store/selectors/reduxFlags';
export const flagsCategories = {
    article: 'article',
    take: 'take',
    dynApproval: 'dynamic approval value',
    ep: 'episode',
    fo: 'folder',
    mo: 'model',
    sh: 'shot',
    pj: 'project',
    dynamicApprovalValue: 'dynamic approval value',
    post: 'post',
};
export default function FlagsComponent(props) {
    const { category, searchInput } = props;
    const dispatch = useDispatch();
    const flags = useSelector(reduxFlagsDataSelector);
    const isLoading = useSelector(reduxFlagsLoadingSelector);
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    const sortedFlagsByCategory = flags
        .filter((flag) => flag.category === category)
        .sort((a, b) => a.name.localeCompare(b.name));
    const categoriesSearchFlags = [...new Set(flags.map((flag) => flagsCategories[flag.category]))];
    const sortedCategories = categoriesSearchFlags.toSorted((a, b) => a.localeCompare(b));
    const searchFlagsByCategories = sortedCategories.map((cat) => {
        const categoryFlags = flags.filter((flag) => flagsCategories[flag.category] === cat);
        return categoryFlags.map((flag) => ({
            cat,
            flag,
        }));
    });
    // input debounce
    useEffect(() => {
        dispatch(setFlagsAreLoading(true));
        const data = setTimeout(() => {
            setDebouncedSearchTerm(searchInput);
        }, 300);
        return () => clearTimeout(data);
    }, [searchInput]);
    useEffect(() => {
        if (debouncedSearchTerm) {
            dispatch(fetchFlagsBySearch({ queries: { query: debouncedSearchTerm } }));
        }
    }, [debouncedSearchTerm]);
    useEffect(() => {
        if (category && !debouncedSearchTerm) {
            dispatch(fetchFlags({ params: { queries: { category } } }));
        }
    }, [category]);
    function onDelete(flag) {
        confirmDelete({
            title: 'Delete',
            render: (_jsxs("div", { children: ["Do you want to delete ", _jsx("b", { children: flag.name }), " ?"] })),
            validateLabelColor: '#E56D7A',
            validateLabel: 'Delete',
            onValidate: () => __awaiter(this, void 0, void 0, function* () { return yield dispatch(deleteFlag(flag.id)); }),
            validateMessage: 'Flag deleted',
        });
    }
    if (isLoading)
        return _jsx(Loader, {});
    return (_jsxs(Widget, { className: classes.flagsContainer, style: { width: '100%' }, children: [_jsx("div", { className: classes.newFlag, children: _jsx(Permission, { actions: ['projet_flags__update'], children: _jsx(ModalTrigger, { modal: _jsx(EditFlagModal, { category: category, categories: flagsCategories, searchInput: searchInput }), children: _jsxs(MUIButton, { icon: "fas-plus", style: { marginLeft: 5 }, children: ["Create a new ", category ? flagsCategories[category] : '', " flag"] }) }) }) }), !isLoading && !searchInput && Object.keys(sortedFlagsByCategory).length === 0 ? (_jsx("div", { className: classes.noFlag, children: "No flag" })) : !isLoading && debouncedSearchTerm && flags.length === 0 ? (_jsx("div", { className: classes.noFlag, children: "No search result" })) : !debouncedSearchTerm ? (_jsx("div", { className: classes.flags, children: sortedFlagsByCategory.map((flag) => (_jsxs("div", { style: {
                        backgroundColor: flag.color,
                        color: getColorFromBackground(flag.color),
                    }, className: classes.flagsItems, children: [_jsx(Tooltip, { title: `Description: ${flag.description || 'No description'}`, children: _jsx("span", { className: classes.flag, children: flag.name }) }), _jsx(Permission, { actions: ['projet_flags__update'], children: _jsx(ModalTrigger, { modal: _jsx(EditFlagModal, { flag: flag, category: flag.category, color: flag.color, categories: flagsCategories, searchInput: debouncedSearchTerm }), children: _jsx(MUIButton, { style: {
                                        color: getColorFromBackground(flag.color),
                                        minWidth: '20px',
                                        minHeight: '20px',
                                    }, className: classes.icon, size: "small", variant: "text", icon: "fas-edit", dataCy: `flags-edit-${flag.name}` }) }) }), _jsx(Permission, { actions: ['projet_flags__update'], children: _jsx(MUIButton, { style: {
                                    color: getColorFromBackground(flag.color),
                                    minWidth: '20px',
                                    minHeight: '20px',
                                }, className: classes.icon, icon: "fas-trash", size: "small", variant: "text", onClick: () => onDelete(flag), dataCy: `flags-delete-${flag.name}` }) })] }, flag.id))) })) : (_jsx("div", { style: { overflowY: 'auto', height: '100%' }, children: searchFlagsByCategories.map((array, i) => {
                    return (_jsxs(Fragment, { children: [_jsx("h3", { children: `${array[0].cat[0].toUpperCase() + array[0].cat.slice(1)} (${array.length}) :` }), _jsx("div", { className: classes.flags, style: { justifyContent: 'flex-start', margin: '0', width: '100%' }, children: array.map((flag) => (_jsxs("div", { style: {
                                        backgroundColor: flag.flag.color,
                                        color: getColorFromBackground(flag.flag.color),
                                    }, className: classes.flagsItems, children: [_jsx(Tooltip, { title: `Description: ${flag.flag.description || 'No description'}`, children: _jsx("span", { className: classes.flag, children: flag.flag.name }) }), _jsx(Permission, { actions: ['projet_flags__update'], children: _jsx(ModalTrigger, { modal: _jsx(EditFlagModal, { flag: flag.flag, category: flag.flag.category, color: flag.flag.color, categories: flagsCategories, searchInput: debouncedSearchTerm }), children: _jsx(MUIButton, { style: {
                                                        color: getColorFromBackground(flag.flag.color),
                                                        minWidth: '20px',
                                                        minHeight: '20px',
                                                    }, className: classes.icon, size: "small", variant: "text", icon: "fas-edit", dataCy: `flags-edit-${flag.flag.name}` }) }) }), _jsx(Permission, { actions: ['projet_flags__update'], children: _jsx(MUIButton, { style: {
                                                    color: getColorFromBackground(flag.flag.color),
                                                    minWidth: '20px',
                                                    minHeight: '20px',
                                                }, className: classes.icon, icon: "fas-trash", size: "small", variant: "text", onClick: () => onDelete(flag.flag), dataCy: `flags-delete-${flag.flag.name}` }) })] }, flag.flag.id))) })] }, i));
                }) }))] }));
}
